import React, { useState, useEffect, useCallback } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import { getProducts } from '../utils/api';
import { toast } from 'react-toastify';
import './Shop.css';

const getSessionSeed = () => {
  let seed = sessionStorage.getItem('shopSeed');
  if (!seed) {
    seed = String(Math.floor(Math.random() * 100000));
    sessionStorage.setItem('shopSeed', seed);
  }
  return parseInt(seed, 10);
};

const seededRandom = (seed) => {
  const x = Math.sin(seed) * 10000;
  return x - Math.floor(x);
};

const shuffleArray = (array) => {
  const shuffled = [...array];
  const seed = getSessionSeed();
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(seededRandom(seed + i) * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

const getProductPriority = (productName) => {
  const name = productName?.toLowerCase() || '';
  if (name.includes('drools') && name.includes('10kg') && name.includes('chicken & egg')) {
    return 1;
  }
  if (name.includes('purepet') && name.includes('10kg') && name.includes('meat & rice')) {
    return 2;
  }
  if (name.includes('chappi') && name.includes('chicken & rice')) {
    return 3;
  }
  return 99;
};

const sortWithSpecialFirst = (products) => {
  const special = [];
  const regular = [];

  products.forEach((product) => {
    const priority = getProductPriority(product.name);
    if (priority < 99) {
      special.push({ product, priority });
    } else {
      regular.push(product);
    }
  });

  special.sort((a, b) => a.priority - b.priority);

  return [...special.map((item) => item.product), ...shuffleArray(regular)];
};

const Shop = () => {
  const [searchParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const filters = {
    petType: searchParams.get('petType') || '',
    category: searchParams.get('category') || '',
    search: searchParams.get('search') || '',
  };

  const loadProducts = useCallback(async () => {
    setLoading(true);
    try {
      const activeFilters = Object.fromEntries(
        Object.entries(filters).filter(([, v]) => v !== '')
      );
      const data = await getProducts(activeFilters);
      setProducts(sortWithSpecialFirst(data.products || []));
    } catch (error) {
      toast.error('Failed to load products');
    } finally {
      setLoading(false);
    }
  }, [filters.petType, filters.category, filters.search]);

  useEffect(() => {
    loadProducts();
  }, [loadProducts]);

  const hasActiveFilters = filters.petType || filters.category || filters.search;

  return (
    <div className="shop-page">
      <div className="container shop-main">
        <div className="products-section">
          <div className="products-header">
            <span className="products-count">
              {products.length} {products.length === 1 ? 'product' : 'products'}
            </span>
            {filters.search && (
              <span className="search-term">Search: &quot;{filters.search}&quot;</span>
            )}
          </div>

          {loading ? (
            <div className="loading-container">
              <div className="spinner"></div>
            </div>
          ) : products.length === 0 ? (
            <div className="no-products">
              <h3>No products found</h3>
              <p>Try a different search or browse from the menu.</p>
              {hasActiveFilters && (
                <Link to="/shop" className="btn btn-primary">
                  View all products
                </Link>
              )}
            </div>
          ) : (
            <div className="products-grid">
              {products.map((product) => (
                <ProductCard key={product._id} product={product} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Shop;
